module.exports = __webpack_public_path__ + "static/media/12-the-hangover-talking.0191f61.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/altcoin/12-the-hangover-talking.mp3
// module id = U2ae
// module chunks = 0